export default __webpack_public_path__ + "static/media/pin-solid.7bd422ac.svg";